import { useCategoryPageSplitFilterQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/useCategoryPageSplitFilterQuery";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";

export const useCategoryPageSplitFilterSections = (): Array<IFilterSection> => {
  return useCategoryPageSplitFilterQuery().data?.filter_sections ?? [];
};
